var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"collapse-panel-title"},[_vm._v("Model")]),_c('p',[_vm._v("Model: "+_vm._s(_vm.model_information.model))]),_c('p',[_vm._v("Brand: "+_vm._s(_vm.model_information.brand))]),_c('p')])}
var staticRenderFns = []

export { render, staticRenderFns }